module.exports = __webpack_public_path__ + "img/bg.731e2a26.jpg";